import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import { withAppContext } from '../../contexts/AppContext';
import AppContextProps from '../../contexts/AppContextProps';
import Breadcrumbs from '../common/Breadcrumbs';
import PageCanvas from '../common/PageCanvas';
import { DefaultContentRequestTableColumns } from './ContentRequestColumnDefinition';
import ContentRequestTable from './ContentRequestTable';

interface AuthorContentRequestsTableState {
  isLoading: boolean;
  contentRequests: any[];
}

class AuthorContentRequestsTable extends React.Component<
  AppContextProps,
  AuthorContentRequestsTableState
> {
  private mplServiceClient: IMplServiceClient;
  private contentRequestTableColumns;

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.mplServiceClient = MplServiceClientFactory.create();
    this.contentRequestTableColumns = DefaultContentRequestTableColumns;

    this.state = {
      contentRequests: [],
      isLoading: true,
    };
  }

  public async componentDidMount() {
    this.loadContentRequests();
  }

  public render() {
    const { isLoading, contentRequests } = this.state;
    const breadcrumbItems = [
      { text: constants.APP_NAME_BREAD_CRUMB, href: '/' },
      { text: constants.AUTHOR_REQUESTS, href: '' },
    ];

    return (
      <div>
        <Breadcrumbs items={breadcrumbItems} />
        <PageCanvas headerText={`Your Content Suggestions`}>
          <ContentRequestTable
            tableId={WorkflowTableIdentity.AuthorContentSuggestions}
            contentRequests={contentRequests}
            columnDefinitions={this.contentRequestTableColumns}
            loading={isLoading}
            onRefreshClick={this.loadContentRequests}
          />
        </PageCanvas>
      </div>
    );
  }

  private loadContentRequests = async () => {
    // @ts-expect-error TS2339 - strict migration
    const { userProfile } = this.props.appContext.authnInfo;
    const { userId } = userProfile;

    this.setState({
      isLoading: true,
    });

    const { contentRequests } =
      await this.mplServiceClient.listContentRequestsForAuthenticatedUser(userId);
    this.setState({
      contentRequests,
      isLoading: false,
    });
  };
}

export default withAppContext(AuthorContentRequestsTable);
